import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  DictionaryField,
  DictionaryFieldFromApi,
} from '../../gk-dynamic-list/services/dictionary/dictionary.model';
import { ApiResponse } from '../services.model';

@Injectable({ providedIn: 'root' })
export class FreeServicesCaseStatusDictionaryService {
  private caseStatus: Observable<DictionaryField[]>;

  constructor(private httpClient: HttpClient) {}

  get(): Observable<DictionaryField[]> {
    if (!this.caseStatus) {
      this.caseStatus = this.httpClient
        .get<
          ApiResponse<DictionaryFieldFromApi[]>
        >('/api/interesant/przp/status/sprawa')
        .pipe(
          map((data) => data.Response),
          map((status) =>
            status.map((item) => DictionaryField.fromApiToApp(item)),
          ),
          shareReplay(1),
        );
    }

    return this.caseStatus;
  }
}
